import { useAnalytics } from '@/services/analytics';
import { cloneAgent } from '@/services/api';
import { logger } from '@/services/logger';
import { useMutation } from 'react-query';
import { useRefetchAgents } from './useRefetchAgents';

export function useCloneAgent() {
    const mixpanel = useAnalytics();
    const { refetchAgents: refetchAgents } = useRefetchAgents();

    return useMutation(cloneAgent, {
        onError: async (error: any, agentId) => {
            await refetchAgents();
            mixpanel?.track('agents-upgrade-v2', { event: 'failure', agentId });
            logger.error(error);
        },
        onSuccess: async (_, agentId) => {
            await refetchAgents();
            mixpanel?.track('agents-upgrade-v2', { event: 'success', agentId });
        },
    });
}
